import { z } from "zod";

import { DbEnum } from "../../../../generated/prisma-enums";

/**
 * Document synchronization operations
 * Includes: EnableSync, DisableSync, TriggerSync, GetSyncStatus, UpdateSyncInterval, GetOrganizationSyncStatus
 */

// ============================================================================
// ENABLE SYNC
// ============================================================================

export const DocumentEnableSyncPathVarsSchema = z.object({
  id: z.string()
});

export const DocumentEnableSyncBodySchema = z.object({
  syncFrequency: z.string()
});

export const DocumentEnableSyncResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  syncFrequency: z.string()
});

// ============================================================================
// DISABLE SYNC
// ============================================================================

export const DocumentDisableSyncPathVarsSchema = z.object({
  id: z.string()
});

export const DocumentDisableSyncResponseSchema = z.object({
  success: z.boolean(),
  message: z.string()
});

// ============================================================================
// TRIGGER SYNC
// ============================================================================

export const DocumentTriggerSyncPathVarsSchema = z.object({
  id: z.string()
});

export const DocumentTriggerSyncResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  lastSyncedAt: z.custom<Date>()
});

// ============================================================================
// GET SYNC STATUS
// ============================================================================

export const DocumentGetSyncStatusPathVarsSchema = z.object({
  id: z.string()
});

export const DocumentGetSyncStatusResponseSchema = z.object({
  syncEnabled: z.boolean(),
  syncFrequency: z.string().nullable(),
  lastSyncedAt: z.string().datetime().nullable(),
  status: z.nativeEnum(DbEnum.DocumentStatus),
  lastSyncResult: z
    .object({
      success: z.boolean(),
      changesDetected: z.boolean(),
      changes: z
        .object({
          added: z.number(),
          updated: z.number(),
          removed: z.number()
        })
        .optional(),
      error: z.string().optional()
    })
    .nullable(),
  nextSyncTime: z.custom<Date>().nullable()
});

// ============================================================================
// UPDATE SYNC INTERVAL
// ============================================================================

export const DocumentUpdateSyncIntervalPathVarsSchema = z.object({
  id: z.string()
});

export const DocumentUpdateSyncIntervalBodySchema = z.object({
  syncFrequency: z.string()
});

export const DocumentUpdateSyncIntervalResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
  syncFrequency: z.string()
});

// ============================================================================
// GET ORGANIZATION SYNC STATUS
// ============================================================================

export const DocumentGetOrganizationSyncStatusResponseSchema = z.object({
  totalSyncEnabled: z.number(),
  syncingNow: z.number(),
  lastSynced: z.custom<Date>().nullable(),
  upcomingSync: z.array(
    z.object({
      documentId: z.string(),
      name: z.string(),
      nextSyncTime: z.custom<Date>()
    })
  )
});
